import { BuildingsIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Office = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <BuildingsIcon {...rest} size={Sizes[size]} color={fill} />;
};

Office.displayName = 'Office';
